/**
 *
 */

(function(window, undefined) {
    'use strict';
    var Route = function($stateProvider, $urlRouterProvider) {
        var onEnter = [
            'CblMessageSrvc',
            function(messaggiSrvc) {
                messaggiSrvc.reset();
            }
        ];
        var runner = [
            'FinanzaRunService',
            '$q',
            function(runService, $q) {
                var defer = $q.defer();
                runService.avvio().then(
                    function() {
                        defer.resolve();
                    },
                    function() {
                        defer.resolve();
                    }
                );

                return defer.promise;
            }
        ];
        var labelRunner = [
            'FinanzaRunService',
            '$q',
            function(runService, $q) {
                var defer = $q.defer();
                runService.avvioLabel().then(
                    function() {
                        defer.resolve();
                    },
                    function() {
                        defer.resolve();
                    }
                );

                return defer.promise;
            }
        ];

        $stateProvider
            .state('sceltadossier', {
                url: '/:ndg/:finServizio/scelta-dossier',
                template: '<finanza-scelta-dossier ' +
                    'class="wrapper" ' +
                    'saldo-dossier-state="saldodossier" ' +
                    'abilita-consulenza-state="abilitaconsulenza"></finanza-scelta-dossier>',
                onEnter: onEnter,
                ncyBreadcrumb: {
                    label: 'Scelta Dossier',
                    parent: 'schedaCliente'
                },
                resolve: {
                    runner: runner
                }
            })
            .state('saldodossier', {
                url: '/:ndg/:finServizio/saldodossier/:finCodiceRapporto/',
                template: '<finanza-saldo-dossier ' +
                    'class="wrapper" ' +
                    'scelta-dossier-state="sceltadossier" ' +
                    'nuova-raccomandazione-state="nuovaraccomandazione" ' +
                    'modifica-raccomandazione-state="modificaraccomandazione" ' +
                    'visualizza-raccomandazione-state="visualizzaraccomandazione" ' +
                    'valutazione-raccomandazione-state="valutazioneraccomandazione" ' +
                    'modifica-richiesta-state="gestionerichiesta" ' +
                    'nuova-richiesta-state="nuovoordine" ' +
                    'visualizza-richiesta-state="visualizzarichiesta"></finanza-saldo-dossier>',
                onEnter: onEnter,
                ncyBreadcrumb: {
                    label: 'Saldo Dossier',
                    parent: 'sceltadossier'
                },
                resolve: {
                    runner: runner
                }
            })
            .state('schedaDossier', {
                url: '/scheda-dossier/:ndg/:finCodiceRapporto',
                template: '<finanza-scheda-dossier class="wrapper"></finanza-scheda-dossier>',
                onEnter: onEnter,
                ncyBreadcrumb: {
                    label: 'Scheda Dossier',
                    parent: 'schedaCliente'
                },
                resolve: {
                    runner: labelRunner
                }
            })
            .state('abilitaconsulenza', {
                url: '/:ndg/:finServizio/:finCodiceRapporto/abilitaconsulenza',
                template: '<finanza-abilita-consulenza ' +
                    'scelta-dossier-state="sceltadossier" ' +
                    'class="wrapper"></finanza-saldo-dossier>',
                onEnter: onEnter,
                ncyBreadcrumb: {
                    label: 'Abilita Consulenza',
                    parent: 'sceltadossier'
                },
                resolve: {
                    runner: runner
                }
            })
            .state('nuovaraccomandazione', {
                url: '/:ndg/:finServizio/:finCodiceRapporto/nuova-raccomandazione/:finIniziativa',
                template: '<finanza-gestione-raccomandazione ' +
                    'class="wrapper" ' +
                    'modalita="nuova" ' +
                    'nuova-proposta-state="nuovaproposta" ' +
                    'saldo-dossier-state="saldodossier"></finanza-gestione-raccomandazione>',
                onEnter: onEnter,
                ncyBreadcrumb: {
                    label: 'Nuova Raccomandazione',
                    parent: 'saldodossier'
                },
                resolve: {
                    runner: runner
                }
            })
            .state('modificaraccomandazione', {
                url: '/:ndg/:finServizio/:finCodiceRapporto/modifica-raccomandazione/:finIdRaccomandazione',
                template: '<finanza-gestione-raccomandazione ' +
                    'class="wrapper" ' +
                    'nuova-proposta-state="nuovaproposta" ' +
                    'modifica-proposta-state="modificaproposta" ' +
                    'visualizza-proposta-state= "visualizzaproposta" ' +
                    'gestione-richiesta-state="gestionerichiesta" ' +
                    'saldo-dossier-state="saldodossier" ' +
                    'visualizza-raccomandazione-state="visualizzaraccomandazione" ' +
                    'modalita="modifica"></finanza-gestione-raccomandazione>',
                onEnter: onEnter,
                ncyBreadcrumb: {
                    label: 'Modifica Raccomandazione',
                    parent: 'saldodossier'
                },
                resolve: {
                    runner: runner
                }
            })
            .state('visualizzaraccomandazione', {
                url: '/:ndg/:finServizio/:finCodiceRapporto/visualizza-raccomandazione/:finIdRaccomandazione/:esterno',
                template: '<finanza-gestione-raccomandazione ' +
                    'class="wrapper" ' +
                    'visualizza-proposta-state="visualizzaproposta" ' +
                    'saldo-dossier-state="saldodossier" ' +
                    'modalita="visualizza"></finanza-gestione-raccomandazione>',
                onEnter: onEnter,
                ncyBreadcrumb: {
                    label: 'Visualizza Raccomandazione',
                    parent: 'saldodossier'
                },
                resolve: {
                    runner: runner
                }
            })
            .state('valutazioneraccomandazione', {
                url: '/:ndg/:finServizio/:finCodiceRapporto/valutazione-raccomandazione/:finIdRaccomandazione',
                template: '<finanza-gestione-raccomandazione ' +
                    'class="wrapper" ' +
                    'nuova-proposta-state="nuovaproposta" ' +
                    'modifica-proposta-state="modificaproposta" ' +
                    'visualizza-proposta-state="visualizzaproposta" ' +
                    'gestione-richiesta-state="gestionerichiesta" ' +
                    'saldo-dossier-state="saldodossier" ' +
                    'visualizza-raccomandazione-state="visualizzaraccomandazione" ' +
                    'modalita="valutazione"></finanza-gestione-raccomandazione>',
                onEnter: onEnter,
                ncyBreadcrumb: {
                    label: 'Valutazione Raccomandazione',
                    parent: 'saldodossier'
                },
                resolve: {
                    runner: runner
                }
            })
            .state('nuovaproposta', {
                url: '/:ndg/:finServizio/:finCodiceRapporto/:finIdRaccomandazione/nuova-proposta/:finCodiceStrumento/:finIntestatarioStrumento/:acqven/:finIniziativa',
                template: '<finanza-gestione-proposta ' +
                    'class="wrapper" ' +
                    'modifica-raccomandazione-state="modificaraccomandazione" ' +
                    'modalita="modifica"></finanza-gestione-proposta>',
                onEnter: onEnter,
                ncyBreadcrumb: {
                    label: 'Nuova Proposta',
                    parent: 'nuovaraccomandazione'
                },
                resolve: {
                    runner: runner
                }
            })
            .state('modificaproposta', {
                url: '/:ndg/:finServizio/:finCodiceRapporto/:finIdRaccomandazione/modifica-proposta/:finIdProposta/:finCodiceStrumento/:finIntestatarioStrumento/:acqven',
                template: '<finanza-gestione-proposta ' +
                    'class="wrapper" ' +
                    'modifica-raccomandazione-state="modificaraccomandazione" ' +
                    'modalita="visualizza"></finanza-gestione-proposta>',
                onEnter: onEnter,
                ncyBreadcrumb: {
                    label: 'Modifica Proposta',
                    parent: 'modificaraccomandazione'
                },
                resolve: {
                    runner: runner
                }
            })
            .state('visualizzaproposta', {
                url: '/:ndg/:finServizio/:finCodiceRapporto/:finIdRaccomandazione/visualizzaproposta/:finIdProposta/:finCodiceStrumento/:finIntestatarioStrumento/:acqven',
                template: '<finanza-gestione-proposta ' +
                    'class="wrapper" ' +
                    'modifica-raccomandazione-state="modificaraccomandazione" ' +
                    'modalita="visualizza"></finanza-gestione-proposta>',
                onEnter: onEnter,
                ncyBreadcrumb: {
                    label: 'Visualizza Proposta',
                    parent: 'modificaraccomandazione'
                },
                resolve: {
                    runner: runner
                }
            })
            .state('gestionerichiesta', {
                url: '/:ndg/:finServizio/:finCodiceRapporto/:finIdRaccomandazione/gestione-richiesta/:finIdRichiesta/:esterno',
                template: '<finanza-gestione-richiesta ' +
                    'class="wrapper" ' +
                    'gestione-ordine-state="modificaordine" ' +
                    'visualizza-ordine-state="visualizzaordine" ' +
                    'visualizza-richiesta-state="visualizzarichiesta" ' +
                    'modalita="modifica" ' +
                    'saldo-dossier-state="saldodossier"></finanza-gestione-richiesta>',
                onEnter: onEnter,
                ncyBreadcrumb: {
                    label: 'Gestione richiesta',
                    parent: 'saldodossier'
                },
                resolve: {
                    runner: runner
                }
            })
            .state('visualizzarichiesta', {
                url: '/:ndg/:finServizio/:finCodiceRapporto/:finIdRaccomandazione/visualizza-richiesta/:finIdRichiesta/:esterno',
                template: '<finanza-gestione-richiesta ' +
                    'class="wrapper" ' +
                    'visualizza-ordine-state="visualizzaordine" ' +
                    'modalita="visualizza" ' +
                    'saldo-dossier-state="saldodossier"></finanza-gestione-richiesta>',
                onEnter: onEnter,
                ncyBreadcrumb: {
                    label: 'Gestione richiesta',
                    parent: 'saldodossier'
                },
                resolve: {
                    runner: runner
                }
            })
            .state('nuovoordine', {
                url: '/:ndg/:finServizio/:finCodiceRapporto/nuovo-ordine/:finCodiceStrumento/:finIntestatarioStrumento/:acqven',
                template: '<finanza-gestione-ordine ' +
                    'class="wrapper" ' +
                    'saldo-dossier-state="saldodossier" ' +
                    'gestione-richiesta-state="gestionerichiesta" ' +
                    'modalita="modifica"></finanza-gestione-ordine>',
                onEnter: onEnter,
                ncyBreadcrumb: {
                    label: 'Gestione ordine',
                    parent: 'gestionerichiesta'
                },
                resolve: {
                    runner: runner
                }
            })
            .state('modificaordine', {
                url: '/:ndg/:finServizio/:finCodiceRapporto/:finIdRaccomandazione/:finIdRichiesta/modifica-ordine/:finIdOrdine/:finCodiceStrumento/:finIntestatarioStrumento/:acqven',
                template: '<finanza-gestione-ordine ' +
                    'class="wrapper" ' +
                    'gestione-richiesta-state="gestionerichiesta" ' +
                    'modalita="modifica"></finanza-gestione-ordine>',
                onEnter: onEnter,
                ncyBreadcrumb: {
                    label: 'Gestione ordine',
                    parent: 'gestionerichiesta'
                },
                resolve: {
                    runner: runner
                }
            })
            .state('visualizzaordine', {
                url: '/:ndg/:finServizio/:finCodiceRapporto/:finIdRaccomandazione/:finIdRichiesta/visualizza-ordine/:finIdOrdine/:finCodiceStrumento/:finIntestatarioStrumento/:acqven',
                template: '<finanza-gestione-ordine ' +
                    'class="wrapper" ' +
                    'visualizza-richiesta-state="visualizzarichiesta" ' +
                    'modalita="visualizza"></finanza-gestione-ordine>',
                onEnter: onEnter,
                ncyBreadcrumb: {
                    label: 'Gestione ordine',
                    parent: 'gestionerichiesta'
                },
                resolve: {
                    runner: runner
                }
            })
            .state('cashflow', {
                url: '/:ndg/:finRapporto/cashflow/:finDivisa/:finCambio/:finDecimali',
                template: '<finanza-cahflow ' + ' class="wrapper"></finanza-cahflow>',
                onEnter: onEnter,
                ncyBreadcrumb: {
                    label: 'Inquiry estratto conto fiscale',
                    parent: 'schedaDossier'
                },
                resolve: {
                    runner: labelRunner
                }
            })
            .state('estrattoConto', {
                url: '/:ndg/:finCodiceRapporto/estrattoConto/:finDivisa/:finCambio/:finDecimali',
                template: '<finanza-estratto-conto ' +
                    ' class="wrapper"></finanza-estratto-conto>',
                onEnter: onEnter,
                ncyBreadcrumb: {
                    label: 'Inquiry estratto conto fiscale',
                    parent: 'schedaDossier'
                },
                resolve: {
                    runner: labelRunner
                }
            });
    };

    Route.$inject = ['$stateProvider', '$urlRouterProvider'];

    angular.module('cbl.finanza.mf').config(Route);
})(window);


/*****************
 ** WEBPACK FOOTER
 ** ./app/app.route.js
 ** module id = 56
 ** module chunks = 1
 **/